import { useContext } from "react";

import { OrdersContext } from "../contexts/OrdersContext";

const useOrdersContext = () => {
  const context = useContext(OrdersContext);

  if (!context) throw new Error("Orders context must be use inside Provider");

  return context;
};

export default useOrdersContext;
